import React from "react";
import { object, number } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import BigNumber from "../../atoms/BigNumber";

import "./numberedCardWithImage.m.css";

const NumberedCardWithImage = ({ story, headlineNumber }) => {
  return (
    <div styleName="wrapper" className="numbered-card-with-image">
      <BigNumber headlineNumber={headlineNumber} />
      <div>
        <div styleName="image-wrapper">
          <CardImage className="card-with-image-zoom" story={story} linkEnable={true} widths={[100, 100, 120]} />
        </div>
        <NewsHeadline story={story} showSponsor={false} />
      </div>
    </div>
  );
};

NumberedCardWithImage.propTypes = {
  story: object.isRequired,
  headlineNumber: number.isRequired,
};

export default NumberedCardWithImage;
